export default {
  agreeTitle: '关于在acbuy网站使用"acbuy联盟"营销服务的协议',
  agreementText: `欢迎您注册acbuy网站并使用其"acbuy联盟"营销服务。本协议由"acbuy联盟"合作伙伴（以下简称"乙方"）与acbuy（以下简称"甲方"）（包括但不限于www.acbuy.com、acbuy手机APP等，以下简称"甲方网站"）就"acbuy联盟"营销服务相关事宜达成。在使用acbuy网站的"acbuy联盟"营销服务之前，乙方应仔细阅读本协议的所有内容，特别是加粗部分，点击"我已阅读并同意"按钮即表示乙方已接受并同意遵守本协议的规定。本协议构成乙方与acbuy之间的协议，具有法律效力。acbuy有权根据业务需要单方面修改本协议条款，如有修改，acbuy将立即在甲方网站上公布修改内容。如果乙方不同意对本协议文本的修改，应立即停止使用"acbuy联盟"渠道的营销服务，否则视为乙方同意对本协议文本的修改。
第1条 定义 1. 消费者：指为注册而访问甲方网站的acbuy会员`,
  dashboard: '仪表板',
  hi: '您好，',
  inviteFriends: '邀请好友',
  inviteFriendsTips:
    '邀请好友加入acbuy，赚取更多现金！邀请越多，赚得越多，无上限。',
  inviteFriendsTips1: '邀请3个活跃账户获得销售权并赚取佣金。',
  totalInvite: '已邀请用户总数',
  myTeam: '我的团队',
  extractMoney: '已结算佣金',
  noExtractMoney: '未结算佣金',
  inviteTitle: '邀请我的朋友',
  copyCode: '复制邀请码',
  poster: '专属海报',
  myLevel: '我的特权',
  youLevel: '您当前的等级',
  commissionRate: '佣金比例',
  experienceValue: '经验值({num}/{total})',
  levelDesc: '等级说明',
  invite: '邀请',
  revenueDetails: '邀请明细',
  registerTime: '注册时间',
  inviteType: '关联关系',
  userMail: '用户邮箱',
  bonus: '奖金',
  myBonus: '我的奖金',
  myBalance: '我的余额',
  applyWithdraw: '申请提现',
  withdrawTips: '提示：由于提现涉及交易费用，建议提现金额高于¥500.00',
  bank: '银行',
  paypalAccount: 'PayPal账户',
  bankAccount: '银行账户',
  bankName: '银行名称',
  withdrawAmount: '提现金额({unit})',
  bonusDetail: '奖金明细',
  directCommission: '直接佣金明细',
  indirectCommission: '间接佣金明细',
  tradeTime: '交易时间',
  packNo: '包裹编号',
  actCommission: '佣金',
  settlementTime: '结算时间',
  levelName: '推广等级',
  packStatus: '包裹状态',
  directExplain: '佣金比例',
  indirectExplain: '间接佣金',
  experienceExplain: '经验值',
  withdrawRecord: '提现记录',
  withdrawTime: '提现时间',
  serialNo: '序列号',
  withdrawStatus: '提现状态',
  team: '团队',
  levelUp: '升级',
  teamInfo: '团队信息',
  teamNum: '团队用户数',
  monthCommission: '本月预计佣金',
  accCommission: '累计结算佣金',
  teamMember: '团队成员',
  promotedMember: '推广成员',
  invitationTime: '邀请时间',
  inviter: '邀请人',
  promotionTime: '推广时间',
  IBAN: 'IBAN',
  swiftCode: 'Swift代码',
  bankAddress: '银行地址',
  setting: '设置',
  profile: '个人资料',
  withdrawMethod: '提现方式',
  myPrerogative: '我的特权',
  verifyEmail: '验证您的邮箱',
  sendCodeTips:
    '我们已向<strong>{email}</strong>发送了验证码。请在下方输入验证码进行验证。',
  noGetEmail: '没有收到邮件？',
  codeErrorTips: '验证码错误，请重试',
  resendTime: '重新发送验证码 ({time}秒)',
  or: '或',
  contactService: '联系在线客服',
  addMethod: '新增提现方式',
  editMethod: '编辑提现方式',
  rePaypalAccount: '重新输入PayPal账户',
  directInvite: '直接邀请',
  indirectInvite: '间接邀请',
  noSameAccount: '账号和确认账号不一致',
  noAddWithdrawMethod: '你没有添加提现方法',
  statusEnum: {
    0: '待发放',
    1: '发放中',
    2: '发放成功',
    3: '发放失败',
    4: '提现撤销'
  },
  userDetail: '用户明细',
  balance: '账户余额',
  withdrawMax: '提现金额要大于¥500.00',
  addPaypalAccount: '添加Paypal账户',
  addBankAccount: '添加银行账户',
  noPaypalAccount: '没有Paypal账户',
  noBankAccount: '没有银行账户',
  estimated: '妥投',
  notEstimated: '未妥投',
  actual: '实际',
  estiamte: '预估',
  directRealtion: '直接关系',
  indirectRealtion: '间接关系',
  experienceValueText: '经验值',
  relatedParcel: '相关包裹',
  empiricalValue: '经验值',
  acquiringTime: '获取时间',
  relatedEmail: '关联邮箱',
  relatedUsers: '关联用户',
  balanceDetail: '余额明细',
  commissionDetail: '佣金明细',
  details: '详情',
  question1: '受邀用户完成提包后，其状态将更新为"已激活"',
  question2: '订单已完成，佣金已转入您的余额账户',
  question3:
    '所有"未确认收货"订单的佣金。订单将在30-60天内验证，然后佣金将转入您的余额账户',
  activatedUser: '已激活用户',
  bankTip: '提款手续费：提款金额的2%',
  selectWithdrawMethod: '选择提现方式',
  currentWithdrawAmount: '当前可提现金额',
  modify: '修改',
  bonusBalance: '可用佣金余额',
  balanceTips1: '1.每月1日(UTC+8)支付上月结算奖金',
  balanceTips2:
    '2.每月1日(UTC+8)至10日(UTC+8)为提款日期，您可以选择在1日(UTC+8)至11日(UTC+8)提款。我们将在20日(UTC+8)前将资金转账给您，转账后，我们将通过电子邮件通知您转账结果。同时，您可以在取款记录中查看转账相关信息。',
  income: '收入',
  expenditure: '支出',
  commissionSettlement: '佣金结算',
  commissionWithdrawal: '佣金提现',
  withdrawalCancellation: '提现取消',
  activeStatus: '激活状态',
  settlePackageNum: '包裹数量',
  activeTime: '激活时间',
  orderTime: '提包时间',
  orderUser: '提包用户',
  actualFreight: '实付运费',
  estimatedCommission: '预估佣金',
  withdrawAccount: '提现账号',
  withdrawType: '提现类型',
  withdrawTypeEnum: {
    2: '提现到余额',
    0: '提现到银行卡'
  },
  applyTime: '申请时间',
  withdrawStatusEnum: {
    0: '审核中',
    1: '提现中',
    2: '提现成功',
    3: '提现拒绝',
    4: '提现取消'
  },
  bankEndNumber: '银行卡尾号',
  cancelWithdraw: '取消提现',
  withdrawalDetails: '提现详情',
  transferVoucher: '转账凭证',
  cancelWithdrawConfirm: '取消提现确认',
  delPackageHint: '确认取消提款后，相应的提款金额将退还给您的佣金余额',
  withdrawTip:
    '每月的1号（UTC+8）- 10号（UTK+8）是提款日，您可以选择在1号(UTC+8)到10号(UTC+8)之间提款',
  hasLogOff: '已注销'
};
